/*jslint node: true, browser: true*/
"use strict";

var $ = require("pli/jquery");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");
var viewModelInit = require("pli/forms-viewmodel");

var dependentRequiredBehaviour = require("../ko-behaviours-dependentrequired");
var ko = require("./reportExtensions");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Class "ReportCriteriaViewModel"
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

function ReportCriteriaViewModel(factories) {
    if (!(this instanceof ReportCriteriaViewModel)) { return new ReportCriteriaViewModel(factories); } // if new was not used, force it now

    //--------------------------------------------------
    this.extras = function ReportCriteriaViewModelExtras() { return; };
    this.extras.reportTypeTitle = ko.observable(null);
    this.extras.description = ko.observable(null);
    this.extras.requireReportName = ko.observable(true);
    this.extras.forceRun = ko.observable(false);
    this.extras.saveRunConfirmForm = pli.forms.registry.saveRunConfirmationForm;

    this.id = this.reportName = pliObservable(null, { trigger: this.extras.requireReportName, expectedValue: true }, dependentRequiredBehaviour);
    this.guid = ko.observable(null);
    this.reportType = "Unknown";

    if (factories) {
        if (factories.main) {
            this.main = ReportCriteriaViewModel.prototype._extend(new factories.main(factories));
        }

        if (factories.advanced) {
            this.advanced = ReportCriteriaViewModel.prototype._extend(new factories.advanced(factories));
        }

        if (factories.computeErrorsCount) {
            this.extras.errorsCountFlat = ko.computed(factories.computeErrorsCount, this);
            this.extras.errorsCountMain = ko.computed(ReportCriteriaViewModel.prototype._computeErrorsCountMain, this);
            this.extras.errorsCount = ko.computed(ReportCriteriaViewModel.prototype._computeErrorsCount, this);
        }

        if (typeof factories.getReportType === "function") {
            this.reportType = factories.getReportType();
        }

        if (typeof factories.setReportHeaderInfo === "function") {
            factories.setReportHeaderInfo(this.reportType, this.extras.reportTypeTitle, this.extras.description);
        }

        if (typeof factories.loadWidgetRecord === "function") {
            this._loadWidgetRecord = factories.loadWidgetRecord;
        }
    }

    this.extras.title = ko.computed(ReportCriteriaViewModel.prototype._computeTitle, this);

    if ((this.main && this.main.isCategoryGroupLoaded) || (this.advanced && this.advanced.isCategoryGroupLoaded)) {
        this._isLoaded = $.when(this.main.isCategoryGroupLoaded, this.advanced.isCategoryGroupLoaded);
    }

    this._reportStartHandler = this._reportStartHandler.bind(this);
}

//--------------------------------------------------
ReportCriteriaViewModel.prototype.closeConfirm = function cancelReportConfirm() {
    this.extras.saveRunConfirmForm.close();
};

//--------------------------------------------------
ReportCriteriaViewModel.prototype.loadViewModel = function loadViewModel(record) {
    if (window.console && window.console.group) { window.console.group("ReportCriteriaViewModel.loadViewModel", record); }

    if (!record) { record = {}; }

    this.guid(record.guid || null);
    this.id.load(record.id);
    this.reportName.load(record.reportName || null);

    if (this.main && typeof this.main.loadViewModel === "function") {
        this.main.loadViewModel(record.main);
    }

    if (this.advanced && typeof this.advanced.loadViewModel === "function") {
        this.advanced.loadViewModel(record.advanced);
    }

    if (window.console && window.console.groupEnd) { window.console.groupEnd(); }
};

//--------------------------------------------------
ReportCriteriaViewModel.prototype.run = function runReport() {
    if (this.extras.isReportDirty() && !this.extras.forceRun()) {
        pli.forms.open(this.extras.saveRunConfirmForm.id);
        return;
    }

    // When running a report, having a report name filled shouldn't be required
    // This flag is to turn off the requirement during validation of view model
    // before running the report
    this.extras.requireReportName(false);

    if (!this.validateDeep()) {
        this.extras.requireReportName(true);
        return;
    }

    this.extras.requireReportName(true);

    // Used in the report generation page to display the title in the header
    pli.reportTitle = this.extras.title();

    // Build report criteria only object
    var criteria = {};
    ko.utils.extend(criteria, this.main);
    ko.utils.extend(criteria, this.advanced);

    // start report
    pli.call({
        name: "Geo-Report-Start",
        data: { reportId: this.reportType, reportData: ko.toJSON(criteria), criteriaPoco: ko.toJS(this) }
    }).always(this._reportStartHandler);
};

//--------------------------------------------------
ReportCriteriaViewModel.prototype.runOnly = function runReportOnly() {
    this.extras.forceRun(true);
    this.run();
    this.extras.forceRun(false);

    this.closeConfirm();
};

//--------------------------------------------------
ReportCriteriaViewModel.prototype.saveAndRun = function saveAndRunReport() {
    // Create a subscription to run report after report is saved.
    if (!this.extras.runAfterSaveSubscription) {
        this.extras.runAfterSaveSubscription = ko.computed(ReportCriteriaViewModel.prototype._runReportAfterSave, this);
    }

    // Save report
    this.safeSaving();

    // Close dialog
    this.closeConfirm();
};

//--------------------------------------------------
ReportCriteriaViewModel.prototype._computeTitle = function computeReportTitle() {
    if (this.reportName()) {
        return this.extras.reportTypeTitle() + " - " + this.reportName();
    }

    return this.extras.reportTypeTitle();
};

//-------------------------------------------
// Calculates number of errors on all navigation pages for report criteria
ReportCriteriaViewModel.prototype._computeErrorsCount = function ReportCriteriaViewModelComputeErrorsCount() {
    var sum = this.extras.errorsCountFlat();

    if (this.main && this.main.extras && this.main.extras.errorsCount) {
        sum += this.main.extras.errorsCount();
    }

    if (this.advanced && this.advanced.extras && this.advanced.extras.errorsCount) {
        sum += this.advanced.extras.errorsCount();
    }

    return sum;
};

//-------------------------------------------
// Since report name textbox is on the main tab on the UI but is in the ReportCriteriaViewModel,
// we must add the error count for report name to the main error count
ReportCriteriaViewModel.prototype._computeErrorsCountMain = function ReportCriteriaViewModelComputeErrorsCountMain() {
    var sum = this.extras.errorsCountFlat();

    if (this.main && this.main.extras && this.main.extras.errorsCount) {
        sum += this.main.extras.errorsCount();
    }

    return sum;
};

//-------------------------------------------
// Extends viewModel with extras.errorsCount
ReportCriteriaViewModel.prototype._extend = function ReportCriteriaViewModelAddExtras(viewModel) {
    if (viewModel) {
        if (!viewModel.extras) {
            viewModel.extras = function viewModelExtras() { return; };
        }

        viewModel.extras.errorsCount = ko.computed(viewModelInit.computeErrorsCount, viewModel);
    }

    return viewModel;
};

//--------------------------------------------------
// Loads criterias values if passed in from query string
ReportCriteriaViewModel.prototype._loadCriteriasFromQueryString = function loadCriteriasFromQueryString(queryString) {
    var queries = queryString.split("&"),
        queryObject = [],
        record,
        pair,
        i,
        l,
        self = this;

    if (queries.length === 0) { return; }

    // Parse query string into an array of key/value pairs
    for (i = 0, l = queries.length; i < l; i += 1) {
        pair = queries[i].split('=');
        queryObject[pair[0]] = pair[1];
    }

    // Validate the parameters
    if (queryObject.date && !ko.reportUtils.validateParametersFromUpcomingEvents(queryObject.date)) {
        return;
    }

    // Duplicating existing criterias, return no need to load widget record
    if (queryObject.duplicate) {
        if (this._isLoaded) {
            this._isLoaded.done(function () {
                self.duplicate();
            });
        } else {
            this.duplicate();
        }

        return;
    }

    if (typeof this._loadWidgetRecord === "function") {
        record = this._loadWidgetRecord(queryObject);

        if (record.main && this.main && typeof this.main.loadFromWidget === "function") {
            this.main.loadFromWidget(record.main);
        }

        if (record.advanced && this.advanced && typeof this.advanced.loadFromWidget === "function") {
            this.advanced.loadFromWidget(record.advanced);
        }
    }

    if (queryObject.run) {
        if (this._isLoaded) {
            this._isLoaded.done(function () {
                self.runOnly();
            });
        } else {
            this.runOnly();
        }
    }
};

//--------------------------------------------------
//  Handles start percent and status call response
ReportCriteriaViewModel.prototype._reportStartHandler = function ReportCriteriaViewModelReportStartHandler(response) {
    if (!response.isError && response.result) {
        pli.dialog.open({ targetUrl: "~~/Reports/Generate#" + response.result.token, width: 1000, height: 700, windowType: "window" });
    }
};

//--------------------------------------------------
//  Handles running the report after saving
ReportCriteriaViewModel.prototype._runReportAfterSave = function computeRunReportAfterSave() {
    if (this.extras.state() === "ready.saved" && this.extras.runAfterSaveSubscription) {
        this.run();

        // Dispose subscription
        this.extras.runAfterSaveSubscription.dispose();
        this.extras.runAfterSaveSubscription = null;
    }
};

//-------------------------------------------
ReportCriteriaViewModel.prototype.validateDeep = viewModelInit.validateDeep;


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = ReportCriteriaViewModel;
module.exports.viewModelPrototype = ReportCriteriaViewModel.prototype;



//////////////////
// WEBPACK FOOTER
// ./app/report/reportCriteriaViewModel.js
// module id = 509
// module chunks = 49